export function hasZipCodeTaxError(_ref) {
  var _calculationErrors$ta;
  let {
    calculationErrors
  } = _ref;
  return (calculationErrors == null || (_calculationErrors$ta = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta = _calculationErrors$ta.validationError) == null || (_calculationErrors$ta = _calculationErrors$ta.fieldViolations) == null ? void 0 : _calculationErrors$ta.some(violationObject => violationObject.field === 'postalCode' && violationObject.description === 'MISSING')) ?? false;
}
export function hasSubdivisionTaxError(_ref2) {
  var _calculationErrors$ta2;
  let {
    calculationErrors
  } = _ref2;
  return (calculationErrors == null || (_calculationErrors$ta2 = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.validationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.fieldViolations) == null ? void 0 : _calculationErrors$ta2.some(violationObject => violationObject.field === 'subdivision' && violationObject.description === 'MISSING')) ?? false;
}

/* istanbul ignore next */
export function hasSubdivisionShippingError(_ref3) {
  var _calculationErrors$ca;
  let {
    calculationErrors
  } = _ref3;
  return (calculationErrors == null || (_calculationErrors$ca = calculationErrors.carrierErrors) == null || (_calculationErrors$ca = _calculationErrors$ca.errors) == null ? void 0 : _calculationErrors$ca.some(_ref4 => {
    var _error$validationErro;
    let {
      error
    } = _ref4;
    return error == null || (_error$validationErro = error.validationError) == null || (_error$validationErro = _error$validationErro.fieldViolations) == null ? void 0 : _error$validationErro.some(_ref5 => {
      let {
        field
      } = _ref5;
      return field === 'shippingDestination.subdivision' || field === 'shippingDestination';
    });
  })) ?? false;
}

/* istanbul ignore next */
export function hasZipCodeShippingError(_ref6) {
  var _calculationErrors$ca2;
  let {
    calculationErrors
  } = _ref6;
  return (calculationErrors == null || (_calculationErrors$ca2 = calculationErrors.carrierErrors) == null || (_calculationErrors$ca2 = _calculationErrors$ca2.errors) == null ? void 0 : _calculationErrors$ca2.some(_ref7 => {
    var _error$validationErro2;
    let {
      error
    } = _ref7;
    return error == null || (_error$validationErro2 = error.validationError) == null || (_error$validationErro2 = _error$validationErro2.fieldViolations) == null ? void 0 : _error$validationErro2.some(_ref8 => {
      let {
        field
      } = _ref8;
      return field === 'postalCode';
    });
  })) ?? false;
}
//# sourceMappingURL=calculationError.utils.js.map